export enum TicketType {
  Paper = 'Paper',
  Card = 'Card',
  RequestCard = 'RequestCard',
  ScanBarcode = 'ScanBarcode',
  RequestCardToCheckIn = 'RequestCardToCheckIn',
  InsertCardToCheckIn = 'InsertCardToCheckIn',
}
